import { render } from "./PostCommentContainer.vue?vue&type=template&id=44068297&scoped=true"
import script from "./PostCommentContainer.vue?vue&type=script&lang=js"
export * from "./PostCommentContainer.vue?vue&type=script&lang=js"

import "./PostCommentContainer.vue?vue&type=style&index=0&id=44068297&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44068297"]])

export default __exports__